import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import Brand from 'helpers/brand'
import BrowserCompatibility from 'helpers/browserCompatibility'
import WindowLocation from 'helpers/windowLocation'

import { useSessionContext } from 'hooks/SessionContext'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

const SiteRebranded = () => {
  const location = useLocation()
  const { session: { companyBrand } } = useSessionContext()

  const newBrand = companyBrand === 'as' ? 'asair_home' : 'trane_home'
  const newBrandName = Brand.brandName(newBrand)

  const newDisplayUrl = `https://${WindowLocation.subdomain()}.${Brand.domainName(newBrand)}.com`

  const originalPathname = location.state.originalPathname
  const searchParams = new URLSearchParams(location.state.originalSearch)
  searchParams.set('redirectedToNewBrand', true)

  const newRedirectUrl = `${newDisplayUrl}${originalPathname}?${searchParams}`

  const rolloutTime = companyBrand === 'as' ? 'rolling it out to our homeowners in the first few months of 2021.' : 'updating the branding in May.'

  return (
    <>
      <S.Border>
        <S.Logos>
          <S.NexiaLogo src="/img/nexia_logo.jpg" alt="Nexia logo" />
          <S.ArrowIcon className="icon-arrow-right-stem-skinny" />
          <S.NewLogo src={Brand.productLogoPath(newBrand)} alt={`${newBrandName} logo`} />
        </S.Logos>

        <S.Paragraph>
          Weʼve recently updated your Diagnostics experience, and have shifted from Nexia™ Diagnostics to our core brand of
          <b> {newBrandName} Diagnostics</b>
          . You may notice a few minor changes in the branding of our site.
        </S.Paragraph>
        <S.Paragraph>
          Please make sure to bookmark the new Diagnostics URL:
          <br />
          <b>{newDisplayUrl} </b>
          so you can skip this message in the future.
        </S.Paragraph>
        <S.Paragraph>
          Also, our homeowner mobile app will be transitioning from Nexia™ to {newBrandName}; we'll be {rolloutTime}
          <br />
          <b>For more information and resources, view our
            <a href={Brand.dealerKitUrl(newBrand)}> Home dealer kit.</a>
          </b>
        </S.Paragraph>
      </S.Border>
      <S.Link href={newRedirectUrl}>
        <Button decoration="positive" text="go to diagnostics" />
      </S.Link>
    </>
  )
}

export default SiteRebranded

const isMobile = BrowserCompatibility.isMobile(navigator.userAgent)
const S = {
  Border: styled.div`
    max-width: 650px;
    margin: 20px auto;
    padding: 2em 3em;
    border: ${color('border')} 1px solid;
    border-radius: 5px;

    @media ${screenSize.small} {
      margin: 0;
      padding: 1em;
      border: none;
    }
  `,
  Logos: styled.div`
    width: fit-content;
    margin: 0 auto;
  `,
  NexiaLogo: styled.img`
    height: ${isMobile ? '40' : '60'}px;
  `,
  ArrowIcon: styled.span`
    margin: 20px 50px;
    vertical-align: middle;
    font-size: ${isMobile ? '20' : '30'}px;
    color: ${color('border')};

    @media ${screenSize.medium} {
      margin: 20px 40px;
    }

    @media ${screenSize.small} {
      margin: 20px;
    }
  `,
  NewLogo: styled.img`
    height: ${isMobile ? '22' : '42'}px;
  `,
  Paragraph: styled.p`
    margin-top: 20px;
  `,
  Link: styled.a`
    display: flex;
    flex-direction: column;
  `
}
